export const muvalReferralURL = () => {
  return `https://book.muval.com.au/new/whole_home?ref=snug`
}
